import clsx from "classnames";
import { getShareButtonTemplate } from "./functions/getShareButtonTemplate.js";
import styles from "./styles.module.scss";

export default function SF_SocialShareCard_001({
  className = "",
  sectionTitle,
  pageTitle,
  pageUrl,
  body,
  shareButtons = ["linkedin", "facebook", "twitter", "email", "whatsapp"],
}) {
  return (
    <div className={clsx(className, styles.root)}>
      {pageTitle && <div className="pageTitle">{sectionTitle}</div>}
      <div className="socials-wrapper">
        {shareButtons.map((templateName) =>
          getShareButtonTemplate(templateName)(pageTitle, pageUrl, body),
        )}
      </div>
    </div>
  );
}
